var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAbstentionPlateiaV2 = function SvgAbstentionPlateiaV2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9C9C9C",
    fillRule: "evenodd",
    d: "M25.06 0c13.782 0 25.058 11.25 25.058 25S38.842 50 25.06 50C11.277 50 0 38.75 0 25S11.277 0 25.06 0zm0 7.143c-9.845 0-17.9 8.036-17.9 17.857s8.055 17.857 17.9 17.857c9.844 0 17.899-8.036 17.899-17.857 0-9.655-7.784-17.584-17.4-17.85l-.5-.007zm0 5.357c6.878 0 12.529 5.637 12.529 12.5s-5.65 12.5-12.53 12.5c-6.879 0-12.53-5.637-12.53-12.5s5.651-12.5 12.53-12.5z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAbstentionPlateiaV2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/abstentionPlateiaV2.ece10356.svg";
export { ForwardRef as ReactComponent };